const createPost = (
  status = null,
  goingToTag = null,
  text = null,
  linkInput = null,
  parentID = null,
  activityID = null,
  isVideo = false
) =>
  `
mutation MyMutation{
  createPost(input: {
    status: ${status},
    goingToTag: ${goingToTag},
    text: ${text},
    ${linkInput}
    parentID: ${parentID},
    activityID: ${activityID},
    is_video: ${isVideo},
    video_ready: ${false}
  }) {
      createdByID
      reactionsCount
      status
      text
      commentsCount
      createdAt
      id
      is_video
      video_ready
      images {
        items {
          assetEntityID
          url
          id
          index
        }
      }
      userObject {
        id
        phoneNumber
        givenName
        familyName
        numberOfVotes
        sumOfVotes
        images(limit: 1) {
          items {
            id
            index
            url
          }
        }
      }
      link {
        imageUrl
        title
        url
      }
      postTagUsers {
        items {
          user {
            id
            givenName
            familyName
            phoneNumber
            images(limit: 1) {
              items {
                id
                url
                index
              }
            }
          }
        }
      }
      postObject {
        createdByID
        reactionsCount
        status
        text
        commentsCount
        createdAt
        id
        activityObject {
        activityEnd
        activityStart
        address
        description
        currency
        id
        name
        locationDescription
        numberOfParticipants
        price
        privacy
        interest {
          id
          parentID
          parentInterest {
            id
            title
          }
        }
        userObject {
          id
          phoneNumber
          givenName
          familyName
          numberOfVotes
          sumOfVotes
          images(limit: 1) {
            items {
              id
              index
              url
            }
          }
        }
        activityAttendance {
          items {
            activityID
            createdByID
            status
            initStatus
            user {
              id
              familyName
              givenName
              phoneNumber
              images(limit: 1) {
                items {
                  id
                  index
                  url
                }
              }
            }
          }
        }
      }
        postTagUsers {
        items {
          user {
            id
            givenName
            familyName
            phoneNumber
            images(limit: 1) {
              items {
                id
                url
                index
              }
            }
          }
        }
      }
        userObject {
          id
          phoneNumber
          givenName
          familyName
          numberOfVotes
          sumOfVotes
          images {
            items {
              id
              index
              url
            }
          }
        }
        link {
          imageUrl
          title
          url
        }
        images {
          items {
            assetEntityID
            url
            id
            index
          }
        }
      }
      activityObject {
        status
        createdByID
        activityEnd
        activityStart
        address
        description
        currency
        id
        name
        locationDescription
        numberOfParticipants
        price
        privacy
        interest {
          id
          parentID
          parentInterest {
            id
            title
          }
        }
        userObject {
          id
          phoneNumber
          givenName
          familyName
          numberOfVotes
          sumOfVotes
          images(limit: 1) {
            items {
              id
              index
              url
            }
          }
        }
        activityAttendance {
          items {
            activityID
            createdByID
            status
            initStatus
            user {
              id
              familyName
              givenName
              phoneNumber
              images(limit: 1) {
                items {
                  id
                  index
                  url
                }
              }
            }
          }
        }
      }
  }
}
`;

// mutation MyMutation(
//   \$status: PostStatus!,
//   \$text: String,
//   \$parentID: ID,
//   \$activityID: ID,
//   \$goingToTag: [ID],
//   $linkVariables
// )

export default createPost;